import { StyleSheet } from 'react-native'
import { grayTextLight, yellowFour, yellowSec, white } from 'theme/colors'

export default StyleSheet.create({
  background: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'flex-start',
    alignItems: 'center',
    paddingHorizontal: 20,
    width: '100%',
    height: '100%',
    backgroundColor: `${white}`,
    position: 'relative',
    borderTopLeftRadius: 12
  },
  container: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    borderRadius: 6,
    padding: 16,
    margin: 20,
    marginBottom: 40,
    borderWidth: 2,
    backgroundColor: `${yellowSec}`,
    borderColor: `${yellowFour}`,
    width: '100%',
    alignSelf: 'center',
    gap: 10
  },
  titleContainer: {
    flexDirection: 'row'
  },
  title: {
    fontSize: 16,
    fontWeight: '600'
  },
  description: {
    fontSize: 14,
    fontWeight: '500'
  },
  warning: {
    marginRight: 10
  },
  emptyMovements: {
    textAlign: 'center',
    fontSize: 16,
    fontWeight: '400',
    color: `${grayTextLight}`
  },
  emptyMovementsContainer: {
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    justifySelf: 'center'
  }
})
